import Constants from "../utils/consts";
import Utils from "../utils/utils";
import moment from "moment";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function addLezione(
  uname,
  token,
  date,
  hour,
  minutes,
  durata,
  id_corso,
  insegnantiIds,
  altri_corsi,
  id_materia,
  id_aula,
  pagamento_quota // Nuovo parametro per gestire il flag pagamento quota
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "addLezioneNew.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        const resp = JSON.parse(body.toString());
        resolve(resp);
      });

      res.on("error", function(error) {
        console.error(error);
      });
    });

    console.log("dateee", date);

    var postData = qs.stringify({
      token: token,
      uname: uname,
      date: date,
      hour: hour,
      minutes: minutes,
      durata: durata,
      ids_insegnanti: insegnantiIds,
      id_corso: id_corso,
      altri_corsi: altri_corsi,
      id_materia: id_materia,
      id_aula: id_aula,
      pagamento_quota: pagamento_quota, // Passato al backend
    });

    req.write(postData);

    req.end();
  });
}
